import React, { useState } from 'react';
import i18n from 'i18n-js';
import RestaurantsTable from './components/RestaurantsTable';
import { TableToolbar } from 'components/shared';
import { Button, Menu, MenuItem, Paper, Tab, Tabs } from '@material-ui/core';
import { RestaurantsCuisinesModal } from './components/RestaurantsCuisinesModal';
import { LabelsModal } from './components/LabelsModal';
import NewRestaurantModal from './components/NewRestaurantDialog';
import { useStyles } from './styles';
import RestaurantsGroupsTable from './components/GroupsTable';
import { useHistory } from 'react-router-dom';

enum RestaurantPageTab {
    List,
    Groups,
}

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: RestaurantPageTab;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index } = props;

    return <>{value === index && children}</>;
}

export const RestaurantsPage = () => {
    const classes = useStyles();
    const history = useHistory();
    const [activeTab, setActiveTab] = useState<RestaurantPageTab>(RestaurantPageTab.List);
    const [showCuisines, setShowCuisines] = useState(false);
    const [showLabels, setShowLabels] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [coolBoxChecked, setCoolBoxChecked] = useState(false);

    function handleTabChange(event: React.ChangeEvent<{}>, newValue: RestaurantPageTab) {
        setActiveTab(newValue);
    }

    function handleCuisineModal() {
        setShowCuisines(!showCuisines);
    }

    function handleLabelsModal() {
        setShowLabels(!showLabels);
    }

    function handleCoolboxCheckbox() {
        setCoolBoxChecked(!coolBoxChecked);
    }

    const handleAddNewMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const handleAddNewMenuClose = () => {
        setAnchorEl(null);
    };

    const handleCreateNewRestaurant = () => {
        handleAddNewMenuClose();
        setShowCreateModal(true);
    };

    const handleCreateNewGroup = () => {
        handleAddNewMenuClose();
        history.push('/restaurants-group/create');
    };

    return (
        <>
            <TableToolbar
                leftActions={[
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        aria-label="simple tabs example"
                        indicatorColor="primary"
                        key={'tabs'}
                    >
                        <Tab
                            label={i18n.t('navigationTabs.restaurantList')}
                            value={RestaurantPageTab.List}
                        />
                        <Tab
                            label={i18n.t('navigationTabs.restaurantGroups')}
                            value={RestaurantPageTab.Groups}
                        />
                    </Tabs>,
                ]}
                rightActions={[
                    <Button
                        variant="outlined"
                        color="primary"
                        key="labels-button"
                        onClick={handleLabelsModal}
                    >
                        {i18n.t('common.labels')}
                    </Button>,
                    <Button
                        variant="outlined"
                        color="primary"
                        key="cuisine-button"
                        onClick={handleCuisineModal}
                    >
                        {i18n.t('restaurant.typesOfCuisine')}
                    </Button>,
                    <Button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        variant="contained"
                        color="primary"
                        key="add-new-button"
                        onClick={handleAddNewMenuClick}
                    >
                        <span>+</span>
                        <span style={{ marginLeft: 12 }}>{i18n.t('button.addNew')}</span>
                    </Button>,
                ]}
            ></TableToolbar>
            <Paper className={classes.tableContainer}>
                <TabPanel
                    value={activeTab}
                    index={RestaurantPageTab.List}
                    children={
                        <RestaurantsTable
                            isCoolBoxChecked={coolBoxChecked}
                            handleCoolboxCheckbox={handleCoolboxCheckbox}
                        />
                    }
                />
                <TabPanel
                    value={activeTab}
                    index={RestaurantPageTab.Groups}
                    children={
                        <RestaurantsGroupsTable
                            isCoolBoxChecked={coolBoxChecked}
                            handleCoolboxCheckbox={handleCoolboxCheckbox}
                        />
                    }
                />
            </Paper>
            <RestaurantsCuisinesModal onClose={handleCuisineModal} isOpen={showCuisines} />
            <LabelsModal onClose={handleLabelsModal} isOpen={showLabels} />
            <NewRestaurantModal
                isVisible={showCreateModal}
                onClose={() => setShowCreateModal(false)}
            />
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: -10,
                    horizontal: 'right',
                }}
                open={anchorEl !== null}
                onClose={handleAddNewMenuClose}
            >
                <MenuItem onClick={handleCreateNewRestaurant}>
                    {i18n.t('common.add') + ' ' + i18n.t('restaurant.newRestaurant')}
                </MenuItem>
                <MenuItem onClick={handleCreateNewGroup}>
                    {i18n.t('restaurant.addNewGroup')}
                </MenuItem>
            </Menu>
        </>
    );
};
